var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#010101;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6,10c0,0-0.8,0-1.3,0.2c-0.6,0.3-0.8,0.9-0.8,2.4c0,0,0.3-0.3,0.8-0.5C19.7,11.6,19.6,10.6,19.6,10z  M18.9,12.5c-0.3,0.2-0.6,0.3-0.9,0.4c-0.7,0.3-0.6,0.7-0.6,1.7V22c0,0,0.8,0.1,1.3-0.2c0.7-0.3,0.8-0.7,0.8-2.2V12 C19.6,12,19.4,12.3,18.9,12.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,16l4,5.9c0,0-1.7,0.2-2.6-0.5c-0.7-0.6-1.1-1.4-2.6-3.4c0,0-0.3-0.5-0.6,0c-1.7,2.4-2,2.9-2.5,3.4 c-0.8,0.8-2.6,0.5-2.6,0.5l4-5.9l-4-6c0,0,1.7-0.3,2.5,0.5c0.6,0.6,1.2,1.5,2.6,3.5c0.3,0.5,0.6,0,0.6,0c1.4-2.1,2-2.9,2.6-3.5 c0.8-0.8,2.5-0.5,2.5-0.5L28,16z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,10l-3.2,12c0,0-1,0.1-1.6-0.2c-0.7-0.3-1-0.6-1.4-2.2c-0.4-1.5-1.4-5.7-1.5-6c-0.2-0.7-0.5-0.7-0.7,0 c-0.1,0.3-1.1,4.6-1.5,6c-0.4,1.6-0.7,1.9-1.4,2.2C4.2,22,3.2,22,3.2,22L0,10c1.1-0.1,2.4,0.4,2.7,1.7l1.7,6.4l1.4-5.2 c0.4-1.6,1-2.3,2.3-2.3c1.3,0,2,0.8,2.3,2.3l1.4,5.2l1.7-6.4C13.6,10.5,14.9,9.9,16,10z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWix);
export default __webpack_public_path__ + "static/media/wix.b980a7c949fba9152e1b5ce31c349135.svg";
export { ForwardRef as ReactComponent };